(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparateur-tableau"] && !Shopify.designMode) return;
  try {
    
/* Comparateur Fun-Esports : filtres, tri et comparaison cote a cote.
   Amelioration progressive : sans JavaScript, le tableau reste complet,
   lisible et indexable. Aucune donnee n'est portee par le script, tout
   est lu sur les attributs data-* rendus par Liquid. */
(function () {
  'use strict';

  function money(cents, root) {
    var loc = root.getAttribute('data-locale') || 'fr';
    var cur = root.getAttribute('data-currency') || 'EUR';
    try {
      return new Intl.NumberFormat(loc, { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) {
      return Math.round(cents / 100) + ' ' + cur;
    }
  }

  function init(root) {
    if (root.getAttribute('data-fe-ready')) { return; }
    root.setAttribute('data-fe-ready', '1');
    var table = root.querySelector('[data-fe-table]');
    if (!table || !table.tBodies.length) { return; }
    var tbody = table.tBodies[0];
    var rows = Array.prototype.slice.call(tbody.rows);
    var budget = root.querySelector('[data-fe-budget]');
    var budgetOut = root.querySelector('[data-fe-budget-out]');
    var sortSel = root.querySelector('[data-fe-sort]');
    var countEl = root.querySelector('[data-fe-count]');
    var clearBtn = root.querySelector('[data-fe-clear]');
    var bar = root.querySelector('[data-fe-bar]');
    var chips = root.querySelector('[data-fe-chips]');
    var pickedEl = root.querySelector('[data-fe-picked]');
    var goBtn = root.querySelector('[data-fe-go]');
    var panel = root.querySelector('[data-fe-panel]');
    var i18n = root.querySelector('[data-fe-i18n-panel]');
    var pills = Array.prototype.slice.call(root.querySelectorAll('.fe-p[data-f]'));
    var sel = { lv: [], brand: [], ratio: [], etat: [] };
    var pocket = false;

    function inSel(list, v) { return list.indexOf(v) > -1; }

    function match(tr) {
      if (sel.lv.length && !inSel(sel.lv, tr.getAttribute('data-lv'))) { return false; }
      if (sel.brand.length && !inSel(sel.brand, tr.getAttribute('data-brand'))) { return false; }
      if (sel.ratio.length && !inSel(sel.ratio, tr.getAttribute('data-ratio'))) { return false; }
      if (sel.etat.length && !inSel(sel.etat, tr.getAttribute('data-etat'))) { return false; }
      if (budget && parseInt(tr.getAttribute('data-price') || '0', 10) > parseInt(budget.value, 10)) { return false; }
      if (pocket && parseFloat(tr.getAttribute('data-size') || '0') >= 3.5) { return false; }
      return true;
    }

    function apply() {
      var n = 0;
      rows.forEach(function (tr) {
        var ok = match(tr);
        tr.hidden = !ok;
        if (ok) { n++; }
      });
      if (countEl) { countEl.textContent = n; }
      if (budgetOut && budget) { budgetOut.textContent = money(parseInt(budget.value, 10), root); }
    }

    function sortRows() {
      if (!sortSel) { return; }
      var mode = sortSel.value;
      var sorted = rows.slice().sort(function (a, b) {
        var pa = parseInt(a.getAttribute('data-price') || '0', 10);
        var pb = parseInt(b.getAttribute('data-price') || '0', 10);
        if (mode === 'price-desc') { return pb - pa; }
        if (mode === 'power') {
          var la = parseInt(a.getAttribute('data-lv') || '0', 10);
          var lb = parseInt(b.getAttribute('data-lv') || '0', 10);
          if (lb !== la) { return lb - la; }
          return pa - pb;
        }
        if (mode === 'size') {
          var sa = parseFloat(a.getAttribute('data-size') || '0');
          var sb = parseFloat(b.getAttribute('data-size') || '0');
          if (sb !== sa) { return sb - sa; }
          return pa - pb;
        }
        return pa - pb;
      });
      sorted.forEach(function (tr) { tbody.appendChild(tr); });
    }

    pills.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-f');
        var val = btn.getAttribute('data-v');
        if (!sel[key]) { return; }
        var i = sel[key].indexOf(val);
        if (i > -1) { sel[key].splice(i, 1); btn.classList.remove('is-on'); btn.setAttribute('aria-pressed', 'false'); }
        else { sel[key].push(val); btn.classList.add('is-on'); btn.setAttribute('aria-pressed', 'true'); }
        apply();
      });
    });

    if (budget) { budget.addEventListener('input', apply); }
    if (sortSel) { sortSel.addEventListener('change', function () { sortRows(); apply(); }); }

    function reset() {
      sel = { lv: [], brand: [], ratio: [], etat: [] };
      pocket = false;
      pills.forEach(function (b) { b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false'); });
      if (budget) { budget.value = budget.max; }
      apply();
    }
    if (clearBtn) { clearBtn.addEventListener('click', reset); }

    /* raccourcis « depart rapide » : ils pilotent les memes filtres */
    Array.prototype.forEach.call(root.querySelectorAll('[data-fe-preset]'), function (a) {
      a.addEventListener('click', function () {
        reset();
        var p = a.getAttribute('data-fe-preset');
        if (p === 'cheap' && budget) { budget.value = Math.min(15000, parseInt(budget.max, 10)); }
        if (p === 'square') { sel.ratio = ['1:1']; }
        if (p === 'ps2') { sel.lv = ['3']; }
        if (p === 'pocket') { pocket = true; }
        pills.forEach(function (b) {
          var on = sel[b.getAttribute('data-f')] && inSel(sel[b.getAttribute('data-f')], b.getAttribute('data-v'));
          b.classList.toggle('is-on', !!on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        apply();
      });
    });

    /* ---- selection et comparaison cote a cote ---- */
    function picks() {
      return rows.filter(function (tr) {
        var c = tr.querySelector('[data-fe-pick]');
        return c && c.checked;
      });
    }
    function nameOf(tr) {
      var b = tr.querySelector('th b');
      return b ? b.textContent.trim() : '';
    }
    function refreshBar() {
      var list = picks();
      if (pickedEl) { pickedEl.textContent = list.length; }
      if (bar) { bar.hidden = list.length === 0; }
      if (!chips) { return; }
      chips.textContent = '';
      list.forEach(function (tr) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = nameOf(tr) + ' ✕';
        b.addEventListener('click', function () {
          var c = tr.querySelector('[data-fe-pick]');
          if (c) { c.checked = false; }
          refreshBar();
        });
        chips.appendChild(b);
      });
    }
    rows.forEach(function (tr) {
      var c = tr.querySelector('[data-fe-pick]');
      if (c) { c.addEventListener('change', refreshBar); }
    });

    if (goBtn && panel) {
      goBtn.addEventListener('click', function () {
        var list = picks();
        if (!list.length) { return; }
        var labels = [];
        Array.prototype.forEach.call(list[0].cells, function (td) {
          var l = td.getAttribute('data-l');
          if (l) { labels.push(l); }
        });
        panel.textContent = '';
        var close = document.createElement('button');
        close.type = 'button';
        close.className = 'fe-close';
        close.textContent = i18n ? i18n.getAttribute('data-fe-i18n-close') : 'X';
        close.addEventListener('click', function () { panel.hidden = true; });
        panel.appendChild(close);

        var t = document.createElement('table');
        var cap = document.createElement('caption');
        cap.textContent = i18n ? i18n.getAttribute('data-fe-i18n-panel') : '';
        t.appendChild(cap);
        var thead = document.createElement('thead');
        var hr = document.createElement('tr');
        hr.appendChild(document.createElement('td'));
        list.forEach(function (tr) {
          var th = document.createElement('th');
          th.scope = 'col';
          th.textContent = nameOf(tr);
          hr.appendChild(th);
        });
        thead.appendChild(hr);
        t.appendChild(thead);
        var tb = document.createElement('tbody');
        labels.forEach(function (label) {
          var r = document.createElement('tr');
          var th = document.createElement('th');
          th.scope = 'row';
          th.textContent = label;
          r.appendChild(th);
          list.forEach(function (tr) {
            var cell = tr.querySelector('[data-l="' + label.replace(/"/g, '\\"') + '"]');
            var td = document.createElement('td');
            if (cell) { td.innerHTML = cell.innerHTML; }
            r.appendChild(td);
          });
          tb.appendChild(r);
        });
        t.appendChild(tb);
        panel.appendChild(t);
        panel.hidden = false;
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    apply();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fe-cmp]'), init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fe-achat"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.feReady === '1') return;
    root.dataset.feReady = '1';

    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var dataEl = $('[data-fe-variants]');
    var variants = [];
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent) || []; } catch (e) { variants = []; }
    }

    var addUrl = root.dataset.cartAddUrl || '/cart/add';
    var cartUrl = root.dataset.cartUrl || '/cart';
    var currency = root.dataset.currency || 'EUR';
    var locale = root.dataset.locale || 'fr';
    var labelAdd = root.dataset.labelAdd || root.dataset.tAdd || 'Ajouter au panier';
    var labelOff = root.dataset.labelOff || 'Indisponible';
    var txtStock = root.dataset.tStock || 'En stock';
    var txtRupture = root.dataset.tRupture || 'Rupture de stock';
    var txtCombi = root.dataset.tCombi || 'Combinaison indisponible';
    var txtRuptureCourt = root.dataset.tRuptureCourt || 'rupture';
    var txtErr = root.dataset.tErr || 'Ajout au panier impossible, réessayez.';

    /* Remise du pack : purement déclarative. Elle ne sert qu’à refléter
       une remise automatique déjà configurée côté Shopify. Aucun prix
       envoyé au panier n’est modifié ici. */
    var bumpPct = parseFloat(root.dataset.bumpPct);
    if (!isFinite(bumpPct) || bumpPct < 0) bumpPct = 0;
    if (bumpPct > 100) bumpPct = 100;

    var fmt;
    try {
      fmt = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
    } catch (e) {
      fmt = { format: function (n) { return n.toFixed(2); } };
    }
    /* La maquette v14 demande une espace insécable avant le symbole
       (394,90 €). On ne retouche que le symbole final : une devise
       préfixée ou non euro ressort inchangée, et une espace déjà
       présente n’est jamais doublée. */
    var FE_EURO = String.fromCharCode(8364);
    var FE_NBSP = String.fromCharCode(160);
    function nbspEuro(s) {
      if (typeof s !== 'string') return s;
      var i = s.length - 1;
      if (i < 0 || s.charAt(i) !== FE_EURO) return s;
      var j = i;
      while (j > 0 && s.charAt(j - 1).trim() === '') j--;
      return s.slice(0, j) + FE_NBSP + FE_EURO;
    }
    function money(cents) { return nbspEuro(fmt.format((cents || 0) / 100)); }

    var form = root.querySelector('form[action*="/cart/add"]') || $('.fe-achat__form');
    var idInput = $('[data-fe-varid]');
    var qtyInput = $('[data-fe-qtyinput]');
    var priceEl = $('[data-fe-price]');
    var capEl = $('[data-fe-cap]');
    var saveEl = $('[data-fe-save]');
    var stockEl = $('[data-fe-stock]');
    var stockLabel = $('[data-fe-stocklabel]');
    var cta = $('[data-fe-cta]');
    var ctaLabel = $('[data-fe-ctalabel]');
    var errEl = $('[data-fe-err]');
    var totalEl = $('[data-fe-total]');
    var totalCapEl = $('[data-fe-totalcap]');
    var relaisEl = $('[data-fe-relais]');
    var relaisMin = relaisEl ? parseInt(relaisEl.getAttribute('data-seuil'), 10) : 0;
    if (!relaisMin || relaisMin < 0) relaisMin = 0;
    var sticky = $('[data-fe-sticky]');
    var stickyPrice = $('[data-fe-stickyprice]');
    var stickyCta = $('[data-fe-stickycta]');
    var stickyLabel = $('[data-fe-stickylabel]');

    var current = variants.length ? variants[0] : null;
    if (idInput) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(idInput.value)) { current = variants[i]; break; }
      }
    }

    /* ---------- galerie ---------- */
    var slides = $$('[data-fe-slide]');
    var thumbs = $$('[data-fe-thumb]');
    var videoSlide = $('[data-fe-videoslide]');

    /* Façade YouTube : l’iframe n’existe qu’après un clic, et elle est
       retirée du DOM dès qu’on quitte la diapositive (coupe le son). */
    function stopVideo() {
      if (!videoSlide) return;
      var frame = videoSlide.querySelector('[data-fe-videoframe]');
      if (!frame) return;
      var ifr = frame.querySelector('iframe');
      if (ifr && ifr.parentNode) ifr.parentNode.removeChild(ifr);
      var poster = frame.querySelector('[data-fe-videoposter]');
      var btn = frame.querySelector('[data-fe-videoplay]');
      if (poster) poster.hidden = false;
      if (btn) btn.hidden = false;
    }

    function playVideo() {
      if (!videoSlide) return;
      var frame = videoSlide.querySelector('[data-fe-videoframe]');
      var btn = frame ? frame.querySelector('[data-fe-videoplay]') : null;
      if (!frame || !btn || frame.querySelector('iframe')) return;
      var src = btn.getAttribute('data-video-src');
      if (!src) return;
      var ifr = document.createElement('iframe');
      ifr.setAttribute('src', src);
      ifr.setAttribute('title', 'Vidéo de présentation');
      ifr.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      ifr.setAttribute('allowfullscreen', 'allowfullscreen');
      ifr.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      var poster = frame.querySelector('[data-fe-videoposter]');
      if (poster) poster.hidden = true;
      btn.hidden = true;
      frame.appendChild(ifr);
    }

    var playBtn = $('[data-fe-videoplay]');
    if (playBtn) {
      playBtn.addEventListener('click', function (ev) {
        ev.preventDefault();
        playVideo();
      });
    }

    function showMedia(mediaId) {
      var found = false;
      slides.forEach(function (s) {
        var on = String(s.dataset.mediaId) === String(mediaId);
        if (on) found = true;
        s.hidden = !on;
        s.classList.toggle('is-on', on);
        if (!on) {
          var v = s.querySelector('video');
          if (v && typeof v.pause === 'function') v.pause();
          if (s === videoSlide) stopVideo();
        }
      });
      if (!found) return;
      thumbs.forEach(function (t) {
        var on = String(t.dataset.mediaId) === String(mediaId);
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.mediaId); });
    });

    /* ---------- options / variantes ---------- */
    function selectedOptions() {
      var out = [];
      $$('[data-fe-opt]').forEach(function (fs) {
        var idx = parseInt(fs.dataset.index, 10);
        var sel = fs.querySelector('[data-fe-sel]');
        if (sel) { out[idx] = sel.value || null; return; }
        var checked = fs.querySelector('[data-fe-sw]:checked');
        out[idx] = checked ? checked.value : null;
      });
      return out;
    }

    function matchVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== null && v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function markUnavailable() {
      var opts = selectedOptions();
      $$('[data-fe-sw]').forEach(function (inp) {
        var idx = parseInt(inp.dataset.index, 10);
        var test = opts.slice();
        test[idx] = inp.value;
        var v = matchVariant(test);
        var label = inp.nextElementSibling;
        if (label) label.classList.toggle('is-off', !(v && v.available));
      });
      $$('[data-fe-sel]').forEach(function (sel) {
        var idx = parseInt(sel.dataset.index, 10);
        Array.prototype.forEach.call(sel.options, function (o) {
          var test = opts.slice();
          test[idx] = o.value;
          var v = matchVariant(test);
          var base = o.getAttribute('data-label') || o.value;
          o.textContent = (v && v.available) ? base : base + ' — ' + txtRuptureCourt;
        });
      });
    }

    function renderVariant(v) {
      current = v;
      if (idInput) idInput.value = v ? v.id : '';

      /* combinaison inexistante (v = null) : on garde le dernier prix affiché */
      if (priceEl && v) priceEl.innerHTML = nbspEuro(v.price_html);
      var showCap = v && v.compare_at_price && v.compare_at_price > v.price;
      if (capEl) {
        capEl.hidden = !showCap;
        capEl.innerHTML = showCap ? nbspEuro(v.cap_html) : '';
      }
      if (saveEl) {
        saveEl.hidden = !showCap;
        if (showCap) {
          var pct = Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price);
          saveEl.textContent = '-' + pct + ' %';
        }
      }
      if (stickyPrice && v) stickyPrice.innerHTML = nbspEuro(v.price_html);

      if (relaisEl) {
        relaisEl.hidden = !(v && relaisMin > 0 && v.price >= relaisMin);
      }
      var ppEl = $('[data-fe-ppmsg]'); if (ppEl && v) ppEl.setAttribute('data-pp-amount', (v.price / 100).toFixed(2));

      var avail = !!(v && v.available);
      if (stockEl) stockEl.classList.toggle('is-off', !avail);
      if (stockLabel) stockLabel.textContent = avail ? txtStock : (v ? txtRupture : txtCombi);
      if (cta) cta.disabled = !avail;
      if (ctaLabel) ctaLabel.textContent = avail ? labelAdd : labelOff;
      if (stickyCta) stickyCta.disabled = !avail;
      if (stickyLabel) stickyLabel.textContent = avail ? labelAdd : labelOff;

      $$('[data-fe-opt]').forEach(function (fs) {
        var checked = fs.querySelector('[data-fe-sw]:checked');
        var out = fs.querySelector('[data-fe-optval]');
        if (out && checked) out.textContent = checked.value;
      });

      if (v && v.media_id) showMedia(v.media_id);
      markUnavailable();
      updateTotal();
    }

    function onOptChange() {
      var v = matchVariant(selectedOptions());
      /* 22/10/2026 : combinaison inexistante -> on n'ajoute plus en silence
         la variante précédente. Bouton désactivé, mention « indisponible ». */
      renderVariant(v);
      if (v && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    $$('[data-fe-sw]').forEach(function (inp) {
      inp.addEventListener('change', onOptChange);
    });
    $$('[data-fe-sel]').forEach(function (sel) {
      sel.addEventListener('change', onOptChange);
    });

    /* ---------- quantité ---------- */
    $$('[data-fe-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var n = parseInt(qtyInput.value, 10) || 1;
        n += parseInt(b.dataset.feQty, 10);
        if (n < 1) n = 1;
        qtyInput.value = n;
        updateTotal();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', updateTotal);

    /* ---------- order bump ---------- */
    var bumps = $$('[data-fe-bump]');

    /* Même arrondi que le rendu Liquid : (prix * mult + 50) / 100 en
       division entière équivaut à Math.round(prix * mult / 100). */
    function bumpNet(cents) {
      if (!bumpPct) return cents;
      return Math.round(cents * (100 - bumpPct) / 100);
    }

    /* La remise automatique Shopify en place est un BXGY : le client achète
       une console, il obtient UN accessoire à -20 %, avec une quantité de 1
       et usesPerOrderLimit à 1. Elle ne porte donc jamais que sur un seul
       article, quel que soit le nombre d’accessoires éligibles au panier.
       Si plusieurs éligibles sont cochés, un seul est réellement remisé :
       on retient le plus cher. Shopify ne documente formellement nulle part
       lequel des articles éligibles reçoit l’allocation, donc on prend
       l’hypothèse la plus favorable au client : c’est la seule qui garantit
       que le montant facturé ne puisse jamais dépasser le montant affiché. */
    function discountHolder() {
      var best = null;
      var bestPrice = -1;
      bumps.forEach(function (b) {
        if (!b.checked) return;
        if (b.dataset.feElig !== '1') return;
        var p = parseInt(b.dataset.price, 10) || 0;
        if (p > bestPrice) { bestPrice = p; best = b; }
      });
      return best;
    }

    /* Ligne qui affiche la remise quand aucun éligible n’est coché : celle du
       produit éligible le plus cher parmi ceux rendus, à titre indicatif.
       C’est exactement la ligne que Liquid a barrée au chargement, donc le
       script et le rendu initial ne peuvent pas diverger. */
    function fallbackHolder() {
      var best = null;
      var bestPrice = -1;
      bumps.forEach(function (b) {
        if (b.dataset.feElig !== '1') return;
        var p = parseInt(b.dataset.price, 10) || 0;
        if (p > bestPrice) { bestPrice = p; best = b; }
      });
      return best;
    }

    /* Une seule ligne barrée à tout instant, jamais deux : celle passée en
       argument. Toutes les autres lignes éligibles repassent au prix plein.
       Les libellés sont ceux pré-formatés par Liquid dans data-bfull et
       data-bnet : aucun montant n’est reformaté ici. */
    function paintBumpLines(holder) {
      bumps.forEach(function (b) {
        if (b.dataset.feElig !== '1') return;
        var label = b.parentNode;
        if (!label) return;
        var cell = label.querySelector('[data-fe-bprice]');
        if (!cell) return;
        var bar = cell.querySelector('[data-fe-bs]');
        var val = cell.querySelector('[data-fe-bv]');
        if (!bar || !val) return;
        bar.textContent = cell.dataset.bfull || bar.textContent;
        if (holder === b) {
          bar.hidden = false;
          val.textContent = cell.dataset.bnet || val.textContent;
        } else {
          bar.hidden = true;
          val.textContent = cell.dataset.bfull || val.textContent;
        }
      });
    }

    function updateTotal() {
      if (!totalEl) return;
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var base = (current ? current.price : 0) * qty;
      var sum = base;
      var full = base;
      /* Le total n’applique la remise qu’au SEUL article porteur, cohérent
         avec l’unique ligne barrée. Quand aucun éligible n’est coché, rien
         n’est remisé dans le total mais la ligne indicative reste barrée. */
      var holder = discountHolder();
      paintBumpLines(holder || fallbackHolder());
      bumps.forEach(function (b) {
        if (!b.checked) return;
        var p = parseInt(b.dataset.price, 10) || 0;
        full += p;
        sum += (b === holder) ? bumpNet(p) : p;
      });
      totalEl.textContent = money(sum);
      if (totalCapEl) {
        if (full > sum) {
          totalCapEl.textContent = money(full);
          totalCapEl.hidden = false;
        } else {
          totalCapEl.textContent = '';
          totalCapEl.hidden = true;
        }
      }
    }
    bumps.forEach(function (b) { b.addEventListener('change', updateTotal); });

    /* Choix de la variante sur une ligne du pack. Le <select> vit dans un
       <div>, plus dans un <label> : cliquer dedans ne coche donc plus la
       case. La propagation est tout de même stoppée, au cas où la ligne
       serait un jour ré-enveloppée. Les libellés de prix sont déjà mis en
       forme par Liquid dans les <option> : on les recopie tels quels, sans
       jamais reformater un montant en JavaScript. */
    $$('[data-fe-bvsel]').forEach(function (sel) {
      var row = sel.closest ? sel.closest('.fe-achat__bump') : sel.parentNode;
      if (!row) return;
      var box = row.querySelector('[data-fe-bump]');
      if (!box) return;
      var stop = function (e) { e.stopPropagation(); };
      sel.addEventListener('click', stop);
      sel.addEventListener('mousedown', stop);
      sel.addEventListener('change', function (e) {
        stop(e);
        var opt = sel.options[sel.selectedIndex];
        if (!opt || opt.disabled) return;
        box.dataset.vid = opt.value;
        if (opt.dataset.price) box.dataset.price = opt.dataset.price;
        var cell = row.querySelector('[data-fe-bprice]');
        if (cell) {
          cell.dataset.bfull = opt.dataset.full || cell.dataset.bfull;
          cell.dataset.bnet = opt.dataset.net || cell.dataset.bnet;
        }
        var plain = row.querySelector('[data-fe-bplain]');
        if (plain) {
          var pv = plain.querySelector('[data-fe-bval]');
          var pc = plain.querySelector('[data-fe-bcap]');
          if (pv) pv.textContent = opt.dataset.full || pv.textContent;
          if (pc) {
            var capTxt = opt.dataset.cap || '';
            pc.textContent = capTxt;
            pc.hidden = capTxt === '';
          }
        }
        /* Vignette : l’URL est déjà calculée par Liquid à 168 pixels et
           posée sur l’option. On la recopie telle quelle, aucune URL d’image
           n’est construite ici. Quand la variante choisie n’a pas d’image
           propre, data-img porte celle du produit, donc le cadre ne se vide
           jamais. Sur un produit sans aucune image il n’y a pas de vignette
           dans la ligne et rien ne se passe. */
        var thumb = row.querySelector('[data-fe-bthumb]');
        if (thumb && opt.dataset.img) {
          thumb.src = opt.dataset.img;
        }
        updateTotal();
      });
    });

    /* ---------- ajout au panier ---------- */
    function collectItems() {
      var items = [];
      /* sans variante valide, on n'envoie rien (pas les seuls accessoires du pack) */
      if (!current) return items;
      if (current) {
        items.push({
          id: current.id,
          quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1
        });
      }
      bumps.forEach(function (b) {
        if (b.checked) items.push({ id: parseInt(b.dataset.vid, 10), quantity: 1 });
      });
      return items;
    }

    function submitCart() {
      var items = collectItems();
      if (!items.length) return;
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      if (cta) { cta.classList.add('is-loading'); cta.disabled = true; }
      if (stickyCta) stickyCta.disabled = true;

      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || 'Ajout impossible.');
          window.location.href = cartUrl;
        })
        .catch(function (err) {
          if (cta) { cta.classList.remove('is-loading'); cta.disabled = false; }
          if (stickyCta) stickyCta.disabled = false;
          if (errEl) {
            errEl.textContent = err.message || txtErr;
            errEl.hidden = false;
          }
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        submitCart();
      });
    }
    if (stickyCta) {
      stickyCta.addEventListener('click', function () { submitCart(); });
    }

    /* ---------- barre sticky ---------- */
    if (sticky && cta && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sticky.hidden = en.isIntersecting; });
      }, { threshold: 0 });
      io.observe(cta);
    }

    renderVariant(current);
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-fe-achat]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["firmware-tableau"] && !Shopify.designMode) return;
  try {
    
/* Filtres et tri du tableau de compatibilite firmware.
   Amelioration progressive : sans JavaScript le tableau reste complet.
   Aucune donnee dans le script, tout est lu sur les attributs data-*. */
(function () {
  'use strict';

  function init(root) {
    if (root.getAttribute('data-fe-ready')) { return; }
    root.setAttribute('data-fe-ready', '1');
    var table = root.querySelector('[data-fe-table]');
    if (!table || !table.tBodies.length) { return; }
    var tbody = table.tBodies[0];
    var rows = Array.prototype.slice.call(tbody.rows);
    var pills = Array.prototype.slice.call(root.querySelectorAll('.fe-p[data-f]'));
    var countEl = root.querySelector('[data-fe-count]');
    var clearBtn = root.querySelector('[data-fe-clear]');
    var sortSel = root.querySelector('[data-fe-sort]');
    var sel = { plat: [], brand: [], os: [], st: [] };

    function anyContains(list, hay) {
      for (var i = 0; i < list.length; i++) {
        if (hay.indexOf(list[i]) > -1) { return true; }
      }
      return false;
    }

    function match(tr) {
      if (sel.plat.length && !anyContains(sel.plat, tr.getAttribute('data-plat') || '')) { return false; }
      if (sel.brand.length && sel.brand.indexOf(tr.getAttribute('data-brand')) < 0) { return false; }
      if (sel.os.length && !anyContains(sel.os, tr.getAttribute('data-os') || '')) { return false; }
      if (sel.st.length && sel.st.indexOf(tr.getAttribute('data-st')) < 0) { return false; }
      return true;
    }

    function apply() {
      var n = 0;
      rows.forEach(function (tr) {
        var ok = match(tr);
        tr.hidden = !ok;
        if (ok) { n++; }
      });
      if (countEl) { countEl.textContent = n; }
    }

    function key(tr, mode) {
      if (mode === 'soc') { return tr.getAttribute('data-soc') || ''; }
      if (mode === 'st') { return tr.getAttribute('data-st') || ''; }
      return tr.getAttribute('data-brand') || '';
    }

    if (sortSel) {
      sortSel.addEventListener('change', function () {
        var mode = sortSel.value;
        rows.slice().sort(function (a, b) {
          var ka = key(a, mode), kb = key(b, mode);
          if (ka === kb) { return 0; }
          return ka < kb ? -1 : 1;
        }).forEach(function (tr) { tbody.appendChild(tr); });
      });
    }

    pills.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var k = btn.getAttribute('data-f');
        var v = btn.getAttribute('data-v');
        if (!sel[k]) { return; }
        var i = sel[k].indexOf(v);
        if (i > -1) { sel[k].splice(i, 1); btn.classList.remove('is-on'); btn.setAttribute('aria-pressed', 'false'); }
        else { sel[k].push(v); btn.classList.add('is-on'); btn.setAttribute('aria-pressed', 'true'); }
        apply();
      });
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        sel = { plat: [], brand: [], os: [], st: [] };
        pills.forEach(function (b) { b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false'); });
        apply();
      });
    }

    apply();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fe-fw]'), init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
